module.exports = __webpack_public_path__ + "img/P28-en.8f2aa25d.png";